import React, { useEffect } from "react";
import { compose, withActions, withAppContext, withState } from "containers/HOC";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import * as utils from "common/utils";
import { getMyOrgRecentPayments } from "containers/MyOrg/_actions";
import { Link } from "react-router-dom";
import GridCell from "./GridCell";
import Grid from "./Grid";
import LoaderSection from "./LoaderSection";
import TileBodyMessage from "components/TileBodyMessage";
import * as icons from "common/icons";

const RecentTransactions = ({ getMyOrgRecentPayments, authContext, paymentsLoading, payments = [] }) => {
    useEffect(() => {
        getMyOrgRecentPayments(3, authContext.accountId);
    }, [authContext.accountId, getMyOrgRecentPayments]);

    return (
        <Panel title="Payment summary" collapsible loading={paymentsLoading} stickyHeaderName="dashboard.recenttransactions.collapsed" collapsed={true}>
            {paymentsLoading && payments.length === 0 ? (
                <LoaderSection />
            ) : (
                <>
                    {payments.length === 0 ? (
                        <PanelBody>
                            <TileBodyMessage className="u-mt-md u-mb-md">
                                <img src={icons.search} alt="Plus" />
                                <p className="lead">No recent payment transactions</p>
                            </TileBodyMessage>
                        </PanelBody>
                    ) : (
                        <PanelBody>
                            <Grid>
                                <GridCell className="u-width1of2"></GridCell>
                                <GridCell className="u-width1of2 u-textRight">
                                    <Link id="view-all" className="Button Button--secondary u-print-none u-mb-sm" to="/app/myOrg">
                                        <i className="icon icon--before icon-dollar" />
                                        <span>View all</span>
                                    </Link>
                                </GridCell>
                            </Grid>
                            <div className="h5 u-mb-sm">Recent transactions</div>
                            <div className="Table Table-Compressed">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Farm</th>
                                            <th>User</th>
                                            <th className="u-textCenter">Invoice</th>
                                            <th className="u-textRight">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payments
                                            .sort((a, b) => b.time - a.time)
                                            .map((a) => {
                                                const { farms = [] } = a;
                                                const farmName = farms.length === 1 ? farms[0].name : "Multi";
                                                const farmId = farms.length === 1 ? farms[0].id : undefined;
                                                return (
                                                    <tr key={a.time}>
                                                        <td valign="top">{utils.dateOnly(a.time)}</td>
                                                        <td valign="top">{farmId ? <Link to={`/app/farm/${farmId}`}>{farmName}</Link> : <span>{farmName}</span>}</td>
                                                        <td valign="top">{a.userFullName}</td>
                                                        <td valign="top" className="u-textCenter">
                                                            {a.invoiceNumber ? (
                                                                <Link to={`/invoice/${a.id}`} target="_blank">
                                                                    {a.invoiceNumber}
                                                                </Link>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </td>
                                                        <td valign="top" className="u-textRight">
                                                            ${a.amountInclGst}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </PanelBody>
                    )}
                </>
            )}
        </Panel>
    );
};

export default compose(
    withAppContext,
    withActions({ getMyOrgRecentPayments }),
    withState((state) => {
        return {
            payments: state.myOrg.payments,
            paymentsLoading: state.myOrg.paymentsLoading,
        };
    })
)(RecentTransactions);
